import React, { useState, useEffect } from "react";
import { fetchUserPlanHistory } from "../../../api/userProfile";
import { useParams } from "react-router-dom";

const PlanHistory = () => {
  const { userId } = useParams();

  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const getUserPlanHistory = async (userId) => {
    try {
      const response = await fetchUserPlanHistory(userId);
      if (response.success) {
        setPlans(response.data);
      } else {
        setError("Failed to fetch plan data.");
      }
    } catch (error) {
      setError("An error occurred while fetching plan data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getUserPlanHistory(userId);
  }, [userId]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div className="text-danger">{error}</div>;
  }

  return (
    <div className="container mt-4 py-4">
      <h6 className="text-left fw-bold">Plan History</h6>

      <div className="mb-4">
        <div className="card-body">
          <div
            className="table-responsive"
            style={{ maxHeight: "300px", borderRadius: "10px" }}
          >
            <table className="table table-bordered mb-0 rounded-3">
              <thead
                className="bg-success text-white table-primary"
                style={{ position: "sticky", top: "0", zIndex: "1" }}
              >
                <tr>
                  <th>Plan Name</th>
                  <th>Total Days</th>
                  <th>Completed Days</th>
                  <th>% Complete</th>
                </tr>
              </thead>
              <tbody>
                {plans.map((plan, index) => (
                  <tr key={index}>
                    <td>{plan.planName}</td>
                    <td>{plan.totalDays}</td>
                    <td>{plan.completedDays}</td>
                    <td>{plan.completionPercentage}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanHistory;
